import React from 'react';
import { Card, Tag, Button } from 'antd';
import { 
  CalendarOutlined, 
  EyeOutlined, 
  UserOutlined,
  LikeOutlined,
  CommentOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Meta } = Card;

const PostCard = ({ post }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-CN', {
      month: 'long',
      day: 'numeric'
    });
  };

  const handleReadMore = () => {
    navigate(`/post/${post.id}`);
  };

  return (
    <Card
      className="post-card"
      hoverable
      cover={
        post.image ? (
          <img 
            alt={post.title} 
            src={post.image} 
            className="post-card-cover"
          />
        ) : (
          <div className="post-card-placeholder">
            <div className="placeholder-text">博客文章</div>
          </div>
        )
      }
    >
      <div className="post-card-header">
        <div className="post-card-meta">
          <span className="post-card-date">
            <CalendarOutlined /> {formatDate(post.createdAt)}
          </span>
          <span className="post-card-views">
            <EyeOutlined /> {post.views || 0}
          </span>
        </div>
        <h3 className="post-card-title">{post.title}</h3>
        <div className="post-card-author">
          <UserOutlined /> {post.author}
        </div>
      </div>

      <Meta
        description={
          <div className="post-card-content">
            <p className="post-card-excerpt">{post.excerpt}</p>
            <div className="post-card-tags">
              {post.tags?.slice(0, 3).map(tag => (
                <Tag key={tag} color="blue">{tag}</Tag>
              ))}
              {post.tags?.length > 3 && (
                <Tag>+{post.tags.length - 3}</Tag>
              )}
            </div>
          </div>
        }
      />

      <div className="post-card-footer">
        <div className="post-card-stats">
          <span className="post-card-stat">
            <LikeOutlined /> {post.likes || 0}
          </span>
          <span className="post-card-stat">
            <CommentOutlined /> {post.comments || 0}
          </span>
        </div>
        <Button 
          type="primary" 
          size="small" 
          onClick={handleReadMore}
        >
          阅读全文
        </Button>
      </div>
    </Card>
  );
};

export default PostCard;